import React, { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Create context
export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  const [dataChanged, setDataChanged] = useState(false);
  const location = useLocation();

  // Check if we're on the dashboard and should show data changed message
  useEffect(() => {
    if (location.pathname === '/' && dataChanged) {
      setNotification({
        type: 'info',
        message: 'You have made changes. Refresh to pull updated data.',
        action: () => window.location.reload()
      });
    }
  }, [location.pathname, dataChanged]);

  // Reset dataChanged when user refreshes
  useEffect(() => {
    const handleBeforeUnload = () => {
      setDataChanged(false);
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const showNotification = (type, message, action = null) => {
    setNotification({ type, message, action });
  };

  const markDataChanged = () => {
    setDataChanged(true);
  };

  const clearNotification = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider
      value={{
        notification,
        showNotification,
        clearNotification,
        markDataChanged,
        dataChanged
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

// Custom hook for using the notification context
export const useNotification = () => useContext(NotificationContext);
